import React from "react";
import { connect } from "react-redux";
import { Route, Navigate } from "react-router-dom";

import Header from "../components/Header";

const PrivateRoute = ({ component: Component, isAdmin, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAdmin ? (
        <div>
          <Header />
          <br />
          <Component {...props} />
        </div>
      ) : (
        <Navigate to="/" />
      )
    }
  />
);

const mapStateToProps = state => ({
  isAdmin: state.auth.role.indexOf("admin") >= 0
});

export default connect(mapStateToProps)(PrivateRoute);
